export enum ReportTypes {
    Estudio = 1,
    Leave = 2,
    Listados = 3,
    Resumenes = 4
}
